import React, { useEffect, useState } from 'react';
import './Header.css';
import CTA from './CTA';
import ME from '../../assets/perfil.jpeg';

const ROLES = [
  'iOS Developer',
  'GenAI Builder',
  'AI Agents Developer'
];

const Header = () => {
  const [roleIndex, setRoleIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setRoleIndex((i) => (i + 1) % ROLES.length);
    }, 2400);
    return () => clearInterval(id);
  }, []);

  return (
    <header id="top">
      <div className="container header__container">
        <div className="header__content">
          <span className="header__badge">
            Available for opportunities
          </span>

          <h1 className="header__title">
            Hi, I&apos;m <span className="header__name">Felipe Alberto</span>
          </h1>

          <div className="header__role">
            <span className="header__role-prefix">{'>'}</span>
            <span key={roleIndex} className="header__role-text">
              {ROLES[roleIndex]}
            </span>
            <span className="header__role-cursor" />
          </div>

          <p className="header__bio">
            I ship <strong>iOS apps</strong> and build <strong>GenAI agents</strong>.
            From Foundation Models on-device to multi-agent workflows with Claude, OpenAI
            and Gemini. Currently at the <strong>Apple Developer Academy</strong> by IPE.
          </p>

          <CTA />

          <div className="header__stats">
            <div className="header__stat">
              <strong>3</strong>
              <span>iOS apps shipped</span>
            </div>
            <div className="header__stat">
              <strong>2×</strong>
              <span>NEXT FIAP finalist</span>
            </div>
            <div className="header__stat">
              <strong>10+</strong>
              <span>GenAI agents built</span>
            </div>
          </div>
        </div>

        <div className="header__visual">
          <div className="me">
            <img
              src={ME}
              alt="Felipe Alberto"
              width="768"
              height="1024"
              loading="eager"
              decoding="async"
              // eslint-disable-next-line react/no-unknown-property
              fetchpriority="high"
            />
          </div>
          <div className="header__chip header__chip--swift">Swift · SwiftUI</div>
          <div className="header__chip header__chip--ai">A2A · Harness</div>
          <div className="header__chip header__chip--apple">Spec Driven Development</div>
        </div>

      </div>
    </header>
  );
};

export default Header;
